module.exports = __webpack_public_path__ + "static/media/SarahSwitek_15_ThatsAll_1.0f6aad78.mp3";